class StringUtilsError extends Error {
	constructor(message: string) {
		super(`StringUtilsError: ${message}`);
		this.name = "StringUtilsError";
	}
}

export const StringUtils = {
	isEmpty(str: string | undefined): boolean {
		if (typeof str !== "string") {
			throw new StringUtilsError("str is not a string");
		}

		return !str || str.trim().length === 0;
	},
};
